// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__e-bDx","rotation":"Loader_rotation__NWdJx"};